<template>
  <div class="purchased-city">
    <div
        class="purchased-city-list"
        element-loading-background="rgba(255, 255, 255, .1)"
    >
        <router-link
            v-for="row in cityList"
            :key="row.cityCode"
            class="city-link"
            :to="useUrban({citycode: row.cityCode})"
        >
          {{row.name}}
        </router-link>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import {useUrban} from "@/router/linkroute";
const visible = ref(false)
const loading = ref( true);
let _cityList = JSON.parse(localStorage.getItem('cityList')) || []
let cities =  _cityList.map(e => {
    return {
      cityCode: e.cityCode,
      name: e.name
    }
})
const cityList = ref(cities);
</script>

<style scoped>
.purchased-city-list{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 30px;
  height: 188px;
  overflow-y: auto;
}

.purchased-city{
  padding: 20px;
  background-color: #fff;
  border-radius: 10px;
  margin: 20px 0;
}

.city-link{
  font-size: 14px;
  padding: 4px 0;
  text-decoration: none;
  color: #1D83E6;
}

</style>